import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAXR_rQlRTV-BZDMqH1tVEuWZ3F7_nUpcM",
  authDomain: "chefco-official.firebaseapp.com",
  projectId: "chefco-official",
  storageBucket: "chefco-official.firebasestorage.app",
  messagingSenderId: "928009064770",
  appId: "1:928009064770:web:862f394ea6416cd12eb8db",
  measurementId: "G-SBC7EPZS6L"
};

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app, "asia-south1");

// Enable Firestore persistent cache (IndexedDB) with multi-tab support.
// Cached data is served instantly on reload; Firestore syncs changes in the background.
const db = initializeFirestore(
  app,
  {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  },
  "default"
);

const auth = getAuth(app);
export { app, functions, db, auth };